import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';
import ConfirmationModal from './ConfirmationModal';

const EditOrganizationModal = ({ show, onHide, organization, onOrganizationUpdated }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [isPublic, setIsPublic] = useState(false);
    const [showConfirmPublishModal, setShowConfirmPublishModal] = useState(false);
    const [publishAction, setPublishAction] = useState(null); // 'publish' or 'unpublish'

    useEffect(() => {
        if (organization) {
            setName(organization.name);
            setDescription(organization.description || '');
            setIsPublic(organization.is_songs_library_public || false);
        }
    }, [organization, show]);

    const handleUpdateDetails = async (e) => {
        e.preventDefault();
        try {
            await apiClient.put(`/organizations/${organization.id}`, { 
                name, 
                description, 
                is_songs_library_public: isPublic 
            });
            onOrganizationUpdated();
            onHide();
            toast.success('Данные организации успешно обновлены.');
        } catch (err) {
            const errorMessage = err.response?.data?.detail || 'Ошибка обновления организации.';
            toast.error(errorMessage);
            onHide();
        }
    };

    const handleSwitchChange = (e) => {
        const targetValue = e.target.checked;
        if (targetValue) {
            setPublishAction('publish');
        } else {
            setPublishAction('unpublish');
        }
        setShowConfirmPublishModal(true);
    };

    const handleConfirmPublishChange = () => {
        if (publishAction === 'publish') {
            setIsPublic(true);
        } else if (publishAction === 'unpublish') {
            setIsPublic(false);
        }
        setShowConfirmPublishModal(false);
        setPublishAction(null);
    };

    return (
        <>
            <Modal show={show} onHide={onHide} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Редактировать организацию</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleUpdateDetails} className="mb-4">
                        <h5>Основные данные</h5>
                        <Form.Group className="mb-3">
                            <Form.Label>Название</Form.Label>
                            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Описание</Form.Label>
                            <Form.Control as="textarea" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="switch"
                                id="edit-org-public-switch"
                                label="Опубликовать базу песен для всех"
                                checked={isPublic}
                                onChange={handleSwitchChange}
                            />
                        </Form.Group>
                        <div className="d-flex justify-content-end">
                            <Button variant="primary" type="submit">Сохранить данные</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <ConfirmationModal
                show={showConfirmPublishModal}
                title={publishAction === 'publish' ? 'Опубликовать фонотеку?' : 'Сделать фонотеку приватной?'}
                message={
                    publishAction === 'publish'
                    ? 'Фонотека этой организации станет публичной. Другие организации смогут видеть и использовать ее песни в режиме "только для чтения". Вы уверены?'
                    : 'Фонотека этой организации станет приватной. Другие организации потеряют к ней доступ, и все ее песни будут удалены из их планов событий. Вы уверены?'
                }
                onConfirm={handleConfirmPublishChange}
                onCancel={() => setShowConfirmPublishModal(false)}
                confirmText="Да, я уверен"
                cancelText="Отмена"
                confirmVariant={publishAction === 'unpublish' ? 'danger' : 'primary'}
            />
        </>
    );
};

export default EditOrganizationModal;
